import { PLATFORM_ADMIN_ROLES } from '@/core/constants/allowed-roles.constant.js'

const routes = [
  {
    name: 'tenant-admin',
    path: '/tenant-admin',
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'tenant-admin',
      allowedRoles: ['client-administrator', 'system-administrator'],
      adminRole: PLATFORM_ADMIN_ROLES,
      breadcrumb: {
        label: 'tenant-admin.breadcrumbs.tenant-admin',
        route: 'tenant-admin-client-home',
      },
    },
    children: [
      {
        path: ':clientId',
        props: true,
        children: [
          {
            name: 'tenant-admin-client-home',
            path: '',
            props: true,
            component: () =>
              import(
                '@/modules/tenant-admin/containers/tenant-admin.container.vue'
              ),
          },
          {
            name: 'tenant-admin-client-modules',
            path: 'client-modules',
            props: true,
            component: () =>
              import(
                '@/modules/tenant-admin/containers/tenant-admin-edit.container.vue'
              ),
            meta: {
              breadcrumb: {
                label: 'tenant-admin.breadcrumbs.client-modules',
                route: 'tenant-admin-client-modules',
              },
            },
          },
          {
            name: 'tenant-admin-tenant-owner',
            path: 'tenant-owner',
            props: true,
            component: () =>
              import(
                '@/modules/tenant-admin/containers/tenant-admin-tenant-owner.container.vue'
              ),
            meta: {
              breadcrumb: {
                label: 'tenant-admin.tabs.tenant-owner.title',
                route: 'tenant-admin-client-home',
              },
            },
          },
        ],
      },
      {
        name: 'tenant-admin-edit-company',
        path: ':clientId/company/:companyId',
        props: true,
        redirect: { name: 'tenant-admin-form-general' },
        component: () =>
          import(
            '@/modules/tenant-admin/containers/tenant-admin-company-edit.container.vue'
          ),
        meta: {
          breadcrumb: {
            label: 'tenant-admin.company.titles.edit',
            route: 'tenant-admin-client-home',
          },
        },
        children: [
          {
            name: 'tenant-admin-form-general',
            path: 'general',
            component: () =>
              import(
                '@/modules/tenant-admin/components/tenant-admin-listing/tenant-admin-listing-general/tenant-admin-listing-general.vue'
              ),
            meta: {
              breadcrumb: {
                label: 'tenant-admin.tabs.general.title',
                route: 'tenant-admin-edit-company',
              },
            },
          },
          {
            name: 'tenant-admin-form-business-structure',
            path: 'business-structure',
            component: () =>
              import(
                '@/modules/tenant-admin/components/tenant-admin-listing/tenant-admin-listing-business-structure/tenant-admin-listing-business-structure.vue'
              ),
            meta: {
              breadcrumb: {
                label: 'tenant-admin.tabs.business-structure.title',
                route: 'tenant-admin-edit-company',
              },
            },
          },
          {
            name: 'tenant-admin-form-physical-structure',
            path: 'physical-structure',
            component: () =>
              import(
                '@/modules/tenant-admin/components/tenant-admin-listing/tenant-admin-listing-physical-structure/tenant-admin-listing-physical-structure.vue'
              ),
            meta: {
              breadcrumb: {
                label: 'tenant-admin.tabs.physical-structure.title',
                route: 'tenant-admin-edit-company',
              },
            },
          },
          {
            name: 'tenant-admin-form-process-structure',
            path: 'process-structure',
            component: () =>
              import(
                '@/modules/tenant-admin/components/tenant-admin-listing/tenant-admin-listing-process-structure/tenant-admin-listing-process-structure.vue'
              ),
            meta: {
              breadcrumb: {
                label: 'tenant-admin.tabs.process-structure.title',
                route: 'tenant-admin-edit-company',
              },
            },
          },
          {
            name: 'tenant-admin-form-business-area-types',
            path: 'business-area-types',
            component: () =>
              import(
                '@/modules/tenant-admin/components/tenant-admin-listing/tenant-admin-listing-business-area-types/tenant-admin-listing-business-area-types.vue'
              ),
            meta: {
              breadcrumb: {
                label: 'tenant-admin.tabs.business-structure-type.title',
                route: 'tenant-admin-edit-company',
              },
            },
          },
          {
            name: 'tenant-admin-form-operation-types',
            path: 'operation-types',
            component: () =>
              import(
                '@/modules/tenant-admin/components/tenant-admin-listing/tenant-admin-listing-operation-type/tenant-admin-listing-operation-type.vue'
              ),
            meta: {
              breadcrumb: {
                label: 'tenant-admin.tabs.operation-type.title',
                route: 'tenant-admin-edit-company',
              },
            },
          },
          {
            name: 'tenant-admin-form-user-management',
            path: 'user-management',
            component: () =>
              import(
                '@/modules/tenant-admin/containers/tenant-user-management.container.vue'
              ),
            meta: {
              breadcrumb: {
                label: 'tenant-admin.tabs.user-management.title',
                route: 'tenant-admin-edit-company',
              },
            },
          },
          {
            name: 'tenant-admin-form-users-mass',
            path: 'users-mass',
            component: () =>
              import(
                '@/modules/tenant-admin/components/tenant-users-mass-import/tenant-users-mass-import.vue'
              ),
            meta: {
              breadcrumb: {
                label: 'tenant-admin.tabs.users-mass.title',
                route: 'tenant-admin-edit-company',
              },
            },
          },
          {
            name: 'tenant-admin-form-structure-mass',
            path: 'structure-mass',
            component: () =>
              import(
                '@/modules/tenant-admin/components/tenant-structure-mass-import/tenant-structure-mass-import.vue'
              ),
            meta: {
              breadcrumb: {
                label: 'tenant-admin.tabs.structure-mass.title',
                route: 'tenant-admin-edit-company',
              },
            },
          },
          {
            name: 'tenant-admin-form-users-mass-update',
            path: 'users-mass/mass-update',
            props: true,
            component: () =>
              import(
                '@/modules/tenant-admin/components/tenant-users-mass-import/tenant-users-mass-update.vue'
              ),
            meta: {
              breadcrumb: {
                label: 'tenant-admin.breadcrumbs.users-mass-update',
                route: 'tenant-admin-form-users-mass',
              },
            },
          },
          {
            name: 'tenant-admin-form-external-sync',
            path: 'user-management/external-sync',
            props: true,
            component: () =>
              import(
                '@/modules/tenant-admin/components/tenant-admin-listing/tenant-admin-external-sync/tenant-admin-external-sync.vue'
              ),
            meta: {
              breadcrumb: {
                label: 'tenant-admin.tabs.user-management.sync.modal.title',
                route: 'tenant-admin-edit-company',
              },
            },
          },
          {
            name: 'tenant-admin-form-user-management-new',
            path: 'user-management/new',
            component: () =>
              import(
                '@/modules/tenant-admin/containers/tenant-user-management-new-user.container.vue'
              ),
            meta: {
              breadcrumb: {
                label: 'tenant-admin.tabs.user-management.user.new',
                route: 'tenant-admin-form-user-management',
              },
            },
          },
          {
            name: 'tenant-admin-form-user-management-edit',
            path: 'user-management/edit/:id',
            component: () =>
              import(
                '@/modules/tenant-admin/containers/tenant-user-management-new-user.container.vue'
              ),
            meta: {
              breadcrumb: {
                label:
                  'tenant-admin.tabs.user-management.user-detail.labels.owner',
                route: 'tenant-admin-form-user-management',
              },
            },
          },
          {
            name: 'tenant-admin-form-group-permissions',
            path: 'group-permissions',
            component: () =>
              import(
                '@/modules/tenant-admin/components/tenant-admin-group-permissions/tenant-admin-group-permissions.vue'
              ),
            meta: {
              breadcrumb: {
                label: 'tenant-admin.tabs.group-permissions.title',
                route: 'tenant-admin-edit-company',
              },
            },
          },
          {
            name: 'tenant-admin-form-group-permissions-new',
            path: 'group-permissions/new',
            component: () =>
              import(
                '@/modules/tenant-admin/components/tenant-admin-group-permissions-new/tenant-admin-group-permissions-new.vue'
              ),
            meta: {
              breadcrumb: {
                label: 'tenant-admin.tabs.group-permissions.group.new.button',
                route: 'tenant-admin-form-group-permissions',
              },
            },
          },
          {
            name: 'tenant-admin-form-group-permissions-edit',
            path: 'group-permissions/edit/:id',
            component: () =>
              import(
                '@/modules/tenant-admin/components/tenant-admin-group-permissions-new/tenant-admin-group-permissions-new.vue'
              ),
            meta: {
              breadcrumb: {
                label: 'tenant-admin.tabs.group-permissions.group.table.groups',
                route: 'tenant-admin-form-group-permissions',
              },
            },
          },
          {
            name: 'tenant-admin-form-sso-configuration',
            path: 'sso-configuration',
            props: true,
            component: () =>
              import(
                '@/modules/tenant-admin/components/tenant-admin-listing/tenant-admin-sso-configuration/tenant-admin-sso-configuration.vue'
              ),
            meta: {
              breadcrumb: {
                label: 'tenant-admin.tabs.sso-configuration.title',
                route: 'tenant-admin-edit-company',
              },
            },
          },
          {
            name: 'tenant-admin-form-dashboard-configuration',
            path: 'dashboard-configuration',
            props: true,
            component: () =>
              import(
                '@/modules/tenant-admin/components/tenant-admin-listing/tenant-admin-dashboard-configuration/tenant-admin-dashboard-configuration.vue'
              ),
            meta: {
              breadcrumb: {
                label: 'tenant-admin.tabs.dashboard-configuration.title',
                route: 'tenant-admin-edit-company',
              },
            },
          },
          {
            name: 'tenant-admin-form-api-keys',
            path: 'api-keys',
            props: true,
            component: () =>
              import(
                '@/modules/tenant-admin/components/tenant-admin-listing/tenant-admin-listing-api-keys/tenant-admin-listing-api-keys.vue'
              ),
            meta: {
              breadcrumb: {
                label: 'tenant-admin.tabs.api-keys.title',
                route: 'tenant-admin-edit-company',
              },
            },
          },
          {
            name: 'tenant-admin-form-shortcuts',
            path: 'shortcuts',
            props: true,
            component: () =>
              import(
                '@/modules/tenant-admin/components/tenant-admin-listing/tenant-admin-listing-shortcuts/tenant-admin-listing-shortcuts.vue'
              ),
            meta: {
              breadcrumb: {
                label: 'tenant-admin.tabs.shortcuts.title',
                route: 'tenant-admin-edit-company',
              },
            },
          },
          {
            name: 'tenant-admin-form-crm',
            path: 'crm',
            props: true,
            component: () =>
              import(
                '@/modules/tenant-admin/components/tenant-admin-listing/tenant-admin-listing-crm/tenant-admin-listing-crm.vue'
              ),
            meta: {
              breadcrumb: {
                label: 'tenant-admin.tabs.crm.title',
                route: 'tenant-admin-edit-company',
              },
            },
          },
        ],
      },
    ],
  },
]

export default routes
